export const PERSONAL_FIELDS = [
  ["fullLegalName", "Full Legal Name"],
  ["companyName", "Company Name"],
  ["ein", "EIN Number"],
  ["ssn", "Social Security Number"],
  ["dob", "Date of Birth"],
  ["mailingAddress", "Mailing Address"],
  ["dietRestrictions", "Diet Restrictions"],
  ["allergies", "Known Allergies"],
];

export const EMERGENCY_FIELDS = [
  ["emergencyName", "Emergency Contact Name"],
  ["emergencyPhone", "Emergency Contact Phone"],
  ["emergencyAddress", "Emergency Contact Address"],
];

export const TEAM_LABELS = {
  manager: "Manager",
  coManager: "Co-Manager",
  dayToDay: "Day-to-Day",
  businessManagement: "Business Management",
  legal: "Legal Representation",
  tourManager: "Tour Manager",
};

export const SOCIAL_LABELS = {
  instagram: "Instagram",
  twitter: "Twitter / X",
  facebook: "Facebook",
  snapchat: "Snapchat",
  tiktok: "TikTok",
  youtube: "YouTube",
  other: "Other",
};

export const SIZE_LABELS = {
  top: "Top",
  pant: "Pant",
  waist: "Waist",
  bust: "Bust",
  shoe: "Shoe",
};

export const PRO_LABELS = {
  ascap: "ASCAP",
  bmi: "BMI",
  sesac: "SESAC",
  soundexchange: "SoundExchange",
  mlc: "The MLC",
};

export const PLATFORM_LABELS = {
  spotify: "Spotify for Artists",
  appleMusic: "Apple Music for Artists",
};

export const BANKING_FIELDS = [
  ["accountHolder", "Account Holder Name"],
  ["bankName", "Bank Name"],
  ["accountType", "Account Type"],
  ["routingNumber", "Routing Number"],
  ["accountNumber", "Account Number"],
];

export const BRAND_GROWTH_FIELDS = [
  ["currentState", "Where You Are Now & Where You Want To Go", true],
  ["currentAudience", "Current Audience", true],
  ["strongestPlatforms", "Strongest Platforms", false],
  ["targetAudience", "Target Audience", true],
  ["brandIdentity", "Brand Identity", true],
  ["upcomingReleases", "Upcoming Releases / Projects", true],
  ["dreamCollabs", "Dream Collaborations", false],
  ["dreamBrands", "Brands You Want to Work With", false],
  ["growthMarkets", "Markets / Cities You Want to Grow In", false],
  ["successVision", "What Success Looks Like in 6–12 Months", true],
];

export const DOC_TYPES = [
  { key: "management_agreement", label: "Management Agreement" },
  { key: "w9", label: "W9 Form" },
  { key: "tech_rider", label: "Tech Rider" },
  { key: "hospitality_rider", label: "Hospitality Rider" },
  { key: "id_dl", label: "ID or Driver's License" },
  { key: "passport", label: "Passport" },
];

export const DOC_TYPE_LABELS = Object.fromEntries(DOC_TYPES.map((d) => [d.key, d.label]));

export const STATUS_STYLES = {
  new: "text-sky-300 border-sky-400/30 bg-sky-400/10",
  reviewed: "text-emerald-300 border-emerald-400/30 bg-emerald-400/10",
  archived: "text-slate-400 border-slate-500/30 bg-slate-500/10",
};
